import { Component, OnInit } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
    selector: 'app-cariq-cloud',
    templateUrl: './cariq-cloud.component.html',
    styleUrls: ['./cariq-cloud.component.scss'],
    standalone: false
})
export class CariqCloudComponent implements OnInit {
  cloudToShow = 0;
  constructor() { }
  Images = IMAGES;
  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  showCarIQCloud(sectionToShow: number) {
    this.cloudToShow = sectionToShow;
  }

}
